import { isNull, getJsonFromStorage, StorageType } from '@hcr/utils'

import { MOCKS_CONFIG } from '../configs'
import type { MocksSettings } from '../models'
import { isMocksSettings } from '../models'

export const loadMocksSettings = (): MocksSettings => {
  const maybeMocksSettings = getJsonFromStorage<MocksSettings>(MOCKS_CONFIG.storageKeyName, StorageType.SESSION)

  if (isNull(maybeMocksSettings)) {
    return MOCKS_CONFIG.default
  }

  if (isMocksSettings(maybeMocksSettings)) {
    return maybeMocksSettings
  }

  return MOCKS_CONFIG.default
}
